search: Yacht Search
proposals: Proposals
emailHistory: Messages
fleetManagement: Manage Fleet
bookings:
  title: Bookings
  dashboard: Dashboard
  addReservation: Add Booking
  historicRecords: Historic Records
  emailNotifications: Email Notifications
  settings: Settings
admin:
  title: Admin
  agenciesAndUsers: Agencies & Users
  cms: CMS
  images: Images
  reports: Reports
  csvUpdater: CSV Updater
  masquerade: Masquerade
  liveInfo: Live Info
  itineraryLocations: Itinerary Locations
  itineraryTemplates: Itinerary Templates
  crows: Crows
  signUpRequests: Sign Up Requests
  videos: Videos
  offers: Offers
  alerts: Alerts
settings:
  title: Account
  myProfile: Edit Profile
  settings: Settings
  signOut: Log Out
